module.exports = __webpack_public_path__ + "img/album18_18.b19b24e8.jpg";